import { UPDATE_ALL_SHOP } from './actionTypes';


export const changeAllShop = (data) => ({
    type: UPDATE_ALL_SHOP,
    payload: data
})
